import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { selectPage } from '../../../selectors/analytics';
import { IPromoPopup } from '../../../types/promosPage';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getNewbuildingCardUrl } from '../../../utils/urls/getNewbuildingCardUrl';

type TAvaliableNewbuildingsList = IPromoModalProps['promo']['availableJks'];

const EMPTY_RESULT: TAvaliableNewbuildingsList = [];

/* istanbul ignore next */
export const useNewbuildingLinks = (promoDetails: IPromoPopup | null): TAvaliableNewbuildingsList => {
  const { config } = useApplicationContext();
  const { siteType } = useSelector(selectPage);

  return useMemo(() => {
    if (!promoDetails) {
      return EMPTY_RESULT;
    }

    const jks: TAvaliableNewbuildingsList = promoDetails.newbuildingLinks.map((link, index) => ({
      id: promoDetails.newbuildingIds[index] || index,
      name: link.name,
      link: getNewbuildingCardUrl({
        baseUrl: link.url,
        uniquePromoId: promoDetails.uniqueId,
        siteType,
        config,
      }),
    }));

    if (jks.length < promoDetails.newbuildingIds.length) {
      promoDetails.newbuildingIds.slice(jks.length).forEach(id => {
        jks.push({
          id,
        });
      });
    }

    return jks;
  }, [promoDetails, siteType, config]);
};
